// Ícone SVG inline da bandeira Diners Club (sem requisição HTTP)
import * as React from 'react';

export function DinersIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Diners Club" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <circle cx="20" cy="16" r="8" fill="#0079BE" />
      <path d="M18 10v12a6 6 0 0 0 0-12z" fill="#fff" />
      <path d="M18 10a6 6 0 0 0 0 12V10z" fill="#fff" opacity=".15" />
      <text
        x="29"
        y="19"
        fontFamily="Arial, Helvetica, sans-serif"
        fontWeight="700"
        fontSize="6"
        fill="#0079BE"
      >
        Diners
      </text>
    </svg>
  );
}
